import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

type CheckSeatMapResponse = Promise<{ available: boolean }>;
function checkSeatMap(offerId: string): CheckSeatMapResponse {
  return api.client
    .get(`/airflow/seatmap/${offerId}`)
    .then(({ data }) => data)
    .catch(err => {
      sentryModel.captureException(
        sentryModel.getReadableError('ERR_FAILED_TO_CHECK_SEAT_MAP', err),
      );
      throw err;
    });
}

function fetchSeatMap(offerId: string, segmentId: string) {
  return api.airflow.seatMap({ offerId, segmentId }).catch(err => {
    sentryModel.captureException(
      sentryModel.getReadableError('ERR_FAILED_TO_FETCH_SEAT_MAP', err),
    );
    throw err;
  });
}

export const seatMapApi = {
  checkSeatMap,
  fetchSeatMap,
};
